import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SafeIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
            fill="currentColor"
         />
         <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.6242 8.77849C16.2337 8.38797 15.6005 8.38797 15.21 8.77849L10.4856 13.5029L8.70706 11.7244C8.31654 11.3339 7.68337 11.3339 7.29285 11.7244C6.90232 12.1149 6.90232 12.7481 7.29285 13.1386L9.77846 15.6242C10.169 16.0147 10.8021 16.0147 11.1927 15.6242L16.6242 10.1927C17.0147 9.80218 17.0147 9.16901 16.6242 8.77849Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SafeIcon
